import { render, staticRenderFns } from "./dismissible_container.vue?vue&type=template&id=e53207c8&"
import script from "./dismissible_container.vue?vue&type=script&lang=js&"
export * from "./dismissible_container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports